import React from "react";
// import BannerHorizontal from 'components/banners/BannerHorizontal'
// import RightNow from "~/components/RightNow";
import TipsHorizontal from "~/components/TipsHorizontal";
import TopArticles from "~/components/TopArticles";
import TopArticlesGrid from "~/components/TopArticlesGrid";
import HotTopics from "~/components/HotTopics";
// import ElectionsBanner from "~/components/specialBanners/ElectionsBanner";
import { asideMappingFactory } from "~/utility/aside";
import { getGaInfo } from "~/utility/gaInfo";
import { useWagonHeight } from "./wagonHeightHook";

const WagonIndex = (props) => {
  const gaInfo = getGaInfo(props, "wIndex");
  const asideMapping = asideMappingFactory({
    headerSuffix: "",
    gaInfo: gaInfo,
  });
  const ref = useWagonHeight("index");
  return (
    <div ref={ref}>      
      {props.flash_news ? null : (        
        <HotTopics hotTopics={props.hot_topics} gaInfo={gaInfo} />
      )}      
      <section className="section">
        <div className="border-top container">
          <TopArticlesGrid
            aside={props.aside}
            articles={props.articles}
            top_article={props.top_article}
            right_now={props.right_now}
            broadcasts={props.broadcasts}
            gaInfo={gaInfo}
          />
          {/* <RightNow items={props.right_now} /> */}
          <TipsHorizontal
            items={props.tips} // noHeaderColumnLine={true}
            gaInfo={gaInfo}
          />
          {/* <BannerHorizontal {...props.banner_horizontal} /> */}
          {(props.splits || []).map(asideMapping)}
        </div>
      </section>
    </div>
  );
};

export default WagonIndex;
